import { ContentIcon } from "@dropbox/dash-component-library";
import { Avatar } from "@dropbox/dig-components/avatar";
import { getInitials } from "@mirage/shared/account";
import styles from "./AvatarIcon.module.css";

export const AvatarIcon = ({ url, name }: { url?: string; name?: string }) => {
  const icon = (
    <Avatar src={url} alt={name} size="small" hasNoOutline={true}>
      {getInitials(name || "")}
    </Avatar>
  );
  return (
    <ContentIcon className={styles.avatarIcon} size="medium" icon={icon} />
  );
};
